import { createFeatureSelector } from '@ngrx/store';

export const ingredientsState = createFeatureSelector<OLO.State, OLO.State.Ingredient[]>('ingredients');
